import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { HotelBookingService } from 'src/app/services/hotel-booking/hotel-booking.service';
import { UiService } from 'src/app/services/ui.service';
@Component({
  selector: 'app-auto-suggestion-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss'],
})
export class SearchModalComponent implements OnInit {
  public suggestionList: any[];
  public currentHeaderData: any = {
    modalSlotEnd : true,
    marl20 : true,
    title : 'Search',
    fs4 : true
  };

  page: number;
  noData: boolean;
  loading: boolean;
  searchTerm: string;
  lastPage: boolean;
  constructor(
    private modalController: ModalController,
    private hotelBookingService: HotelBookingService,
    private uiService: UiService
  ) {}

  ngOnInit() {
    this.initPageState();
  }
  initPageState() {
    this.suggestionList = [];
    this.page = 0;
    this.noData = false;
    this.loading = false;
    this.lastPage = false;
  }
  selectSuggestion(item) {
    this.modalController.dismiss({
      ...item,
    });
  }
  closeModal() {
    this.modalController.dismiss();
  }
  async getAutoSuggestions() {
    this.initPageState();
    this.loading = true;
    this.hotelBookingService
      .getCityHotelSuggestions(this.searchTerm, this.page)
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((response) => {
        if (response?.last) {
          this.lastPage = true;
        }
        if (response?.content?.length > 0) {
          this.suggestionList = response.content;
        } else {
          this.noData = true;
        }
      });
  }

  getNextPage(event) {
    this.page++;
    this.hotelBookingService
      .getCityHotelSuggestions(this.searchTerm, this.page)
      .pipe(
        finalize(() => {
          event.target.complete();
        })
      )
      .subscribe((response) => {
        if (response?.last) {
          event.target.disabled = true;
        }
        if (response?.content?.length > 0) {
          this.suggestionList = this.suggestionList.concat(response.content);
        }
      });
  }

  filterLIst(event) {
    const searchTerm = event.srcElement.value;
    if (searchTerm.length > 2) {
      this.searchTerm = searchTerm;
      this.getAutoSuggestions();
    }
  }

  filterListOnEnter(event) {
    const searchTerm = event.srcElement.value;
    this.searchTerm = searchTerm;
    this.getAutoSuggestions();
  }
}
